<script>
  import BlockGlobal from "./BlockGlobal.svelte";
  import ButtonAdvanced from "./ButtonAdvanced.svelte";
  import TextBlock from "./TextBlock.svelte";
  import {M} from "../../external";

  export let data;

</script>

<TextBlock heading={M.HEADING_WIDGET_NAME} bind:data={data.heading} isCollapsable={true} isCollapsed={true}/>
<TextBlock heading={M.FOOTER} bind:data={data.footer} isCollapsable={true} isCollapsed={true}/>
<ButtonAdvanced bind:data={data.button} disable={["blockGlobal"]} isCollapsable={true} isCollapsed={true}/>
<BlockGlobal bind:data isCollapsable={true} isCollapsed={true} />
